export default __webpack_public_path__ + "static/media/84.517970cd.png";